import EnvironmentIndicator from './EnvironmentIndicator';

export default EnvironmentIndicator;
